import {
  postWithNoToken
} from '../configApi'

export async function register(body) {
  return await postWithNoToken(`/account/tula/register`, body)
}